import __ from "src/utils/Translations";
import useIsAhr from "src/utils/hooks/useIsAhr";
import { useCompanyId, useCompanyName } from "src/Pages/Company/CompanyContext";
import { getCompanyBaseBreadcrumbs } from "src/Pages/Company/routerHelper";
import BreadcrumbsMui from "src/Components/BreadcrumbsMui/BreadcrumbsMui";
import React from "react";
import { Typography } from "@mui/material";
import SyncErrorsTable from "./Table/SyncErrorsTable";

const SyncErrors = () => {
  const companyId = useCompanyId();
  const isAhr = useIsAhr();
  const companyName = useCompanyName();

  const baseBreadcrumbs = (
    getCompanyBaseBreadcrumbs(companyId, companyName) as {
      title: string;
      link: string;
    }[]
  ).map(({ title, link }) => ({
    label: title,
    to: link,
  }));

  const breadcrumbs = isAhr
    ? [
        {
          label: `${__("Zarządzanie firmą")} ${companyName}`,
          to: `/ahr`,
        },
        {
          label: __("Błędy synchronizacji"),
          to: `/ahr/sync-errors`,
        },
      ]
    : [
        ...baseBreadcrumbs,
        {
          label: __("Zarządzanie pracownikami"),
          to: `/company/edit/${companyId}/employee-management`,
        },
        {
          label: __("Błędy synchronizacji"),
          to: `/company/edit/${companyId}/employee-management/sync-errors`,
        },
      ];

  return (
    <>
      <BreadcrumbsMui items={breadcrumbs} />
      <Typography
        variant="h4"
        fontWeight="fontWeightBold"
        mt={2}
        mb={6}
      >
        {__("Błędy synchronizacji")}
      </Typography>
      <SyncErrorsTable />
    </>
  );
};

export default SyncErrors;
